import { FooterComponentProps } from "@/src/components/Footer/lib/type";
import { HeaderComponentProps } from "@/src/components/Header/lib/type";
import { BASE_URLS, GET } from "@/src/shared/api";
import {throwMaintanceError} from "@/src/shared/utils/maintanceError";

// 15 min
const revalidateLayoutComponentsTime = 900;

export const getHeaderComponent =
  async (): Promise<HeaderComponentProps | null> => {
    try {
      const response = await GET(`${BASE_URLS.HEADER}`, {
        next: { revalidate: revalidateLayoutComponentsTime },
      });
      const data = await response.json();
      return data;
    } catch (e: any) {
        if (process.env.BUILD) {
            return null;
        }
        throwMaintanceError(e);
        return null;
    }
  };

export const getFooterComponent =
  async (): Promise<FooterComponentProps | null> => {
    try {
      const response = await GET(`${BASE_URLS.FOOTER}`, {
        next: { revalidate: revalidateLayoutComponentsTime },
      });
      const data = await response.json();
      return data;
    } catch (e: any) {
        if (process.env.BUILD) {
            return null;
        }
        throwMaintanceError(e);
        return null;
    }
  };

export const getBannersComponent = async (): Promise<any[] | null> => {
  try {
    const searchParams = new URLSearchParams();
    searchParams.append("displayNames", "main-banner");

    const response = await GET(
      `${BASE_URLS.WEB_PAGE_COMPONENT}?` + searchParams.toString(),
      {
        next: { revalidate: 10 },
      },
    );
    const data = await response.json();
    return data;
  } catch (e) {
    console.error("Header fetching component error", e);
    return null;
  }
};
